import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'

import { InputField, TextareaField } from '../../components/inputs'
import LoaderButton from '../../components/loaderButton'
import { ReduxFormProps } from '../../forms'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  cancel: Callback
}
export interface FormProps {
  comment: string
  subject: string
}

export class UserCreateTicketForm extends Component<
  ReduxFormProps<Props, FormProps>
> {
  render() {
    const { handleSubmit, submitting, cancel } = this.props

    return (
      <form
        className="form create-ticket__form"
        name="UserCreateTicketForm"
        onSubmit={handleSubmit}
        data-testid="user-create-ticket-form"
      >
        <h2 className="form__header">Create a Zendesk Ticket</h2>
        <hr className="form__hr form__hr--margin-top" />

        <div
          className=""
          // disabled={submitting} // TODO-TS
        >
          <Field
            className="create-ticket__form-input"
            type="text"
            label="Subject"
            name="subject"
            data-testid="create-ticket-form-subject-input"
            component={InputField}
          />

          <Field
            type="textarea"
            label="Comment"
            name="comment"
            component={TextareaField}
            data-testid="create-ticket-form-comment-input"
            className="create-ticket__form-input"
          />

          <div className="form__button-group create-ticket__form-buttons">
            <LoaderButton
              type="submit"
              className="button button--primary-round"
              data-testid="create-ticket-form-submit"
              isLoading={submitting}
            >
              Submit
            </LoaderButton>
            <a
              onClick={cancel}
              data-testid="create-ticket-form-cancel"
              className="button button--secondary-round"
            >
              Cancel
            </a>
          </div>
        </div>
      </form>
    )
  }
}

export const validate = (data) => {
  const { subject, comment } = data
  const errors: Partial<FormProps> = {}

  if (!subject) {
    errors.subject = 'Subject required'
  }

  if (!comment) {
    errors.comment = 'Comment required'
  }

  return errors
}

export default reduxForm<FormProps, Props>({
  form: 'userCreateTicketFrom',
  validate,
  enableReinitialize: false,
  destroyOnUnmount: true,
})(UserCreateTicketForm)
